export interface ChatSuggestionsProps {
  questions: readonly string[];
  onSelect: (question: string) => void;
  disabled?: boolean;
}

/** Starter questions listed above the composer. */
export function ChatSuggestions({ questions, onSelect, disabled }: ChatSuggestionsProps) {
  if (questions.length === 0) return null;

  return (
    <div className="mb-3">
      <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-ink-faint">
        Sugerencias
      </div>
      <div className="flex flex-col gap-1.5">
        {questions.map((question) => (
          <button
            key={question}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(question)}
            className="rounded-lg border border-line bg-canvas px-3 py-2 text-left text-[12.5px] font-semibold text-ink-body transition-colors hover:bg-line-subtle disabled:opacity-50"
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
}
